import { useState } from "react";
import Modal from "components/Modal";
import Button, { SIZE } from "components/Button";
import styles from "./GmailAccessPopup.module.scss";

const GmailAccessPopup = ({ setShowModal, authorizationUrl }) => {
  const [showWarning, setShowWarning] = useState(false);

  const handleAccept = () => {
    window.location.href = authorizationUrl;
  };

  const handleDeny = () => {
    if (showWarning) {
      setShowModal(false);
    } else {
      setShowWarning(true);
    }
  };

  return (
    <Modal
      className={styles.modal}
      content={
        <div className={styles.content}>
          <h2 className={styles.title}>Gmail Access Required</h2>
          <p className={styles.message}>
            {showWarning
              ? "Some platform functionality may be limited, are you sure?"
              : "For the proper functioning of the Platform we require access to your Gmail account."}
          </p>
          <div className={styles.buttons}>
            <Button
              size={SIZE.LARGE}
              onClick={handleAccept}
            >
              Confirm
            </Button>
            <Button
              size={SIZE.LARGE}
              onClick={handleDeny}
            >
              Deny
            </Button>
          </div>
        </div>
      }
      setShowModal={setShowModal}
      hideCloseBtn={true}
    />
  );
};

export default GmailAccessPopup; 